(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["da-ring-film-v2"] && !Shopify.designMode) return;
  try {
    
  function prepareDaRingFilmVideo(video) {
    if (! video) {
      return;
    }

    video.autoplay = true;
    video.defaultMuted = true;
    video.muted = true;
    video.playsInline = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
  }

  function clearDaRingFilmVideoRetry(video) {
    if (! video || ! video.daRingFilmRetryTimer) {
      return;
    }

    window.clearTimeout(video.daRingFilmRetryTimer);
    video.daRingFilmRetryTimer = null;
  }

  function loadDaRingFilmLazyVideo(video) {
    if (! video) {
      return false;
    }

    prepareDaRingFilmVideo(video);

    var sources = video.querySelectorAll("source[data-src]");
    if (! sources.length || video.dataset.daRingFilmLoaded === "true") {
      return false;
    }

    sources.forEach(function(source) {
      source.src = source.dataset.src;
      source.removeAttribute("data-src");
    });

    video.dataset.daRingFilmLoaded = "true";
    video.preload = "metadata";
    video.load();
    return true;
  }

  function scheduleDaRingFilmVideoRetry(video) {
    if (
      ! video
      || video.dataset.daRingFilmWantsPlay !== "true"
      || video.daRingFilmRetryTimer
    ) {
      return;
    }

    var retryCount = Number(video.dataset.daRingFilmRetryCount || 0);
    if (retryCount >= 3) {
      return;
    }

    video.daRingFilmRetryTimer = window.setTimeout(function() {
      video.daRingFilmRetryTimer = null;

      if (
        document.hidden
        || video.dataset.daRingFilmWantsPlay !== "true"
      ) {
        return;
      }

      video.dataset.daRingFilmRetryCount = String(retryCount + 1);

      if (video.error || video.networkState === 3) {
        video.load();
      }

      playDaRingFilmLazyVideo(video, false);
    }, 1800 * (retryCount + 1));
  }

  function playDaRingFilmLazyVideo(video, forceReload) {
    if (! video) {
      return;
    }

    prepareDaRingFilmVideo(video);
    video.dataset.daRingFilmWantsPlay = "true";

    var sourceWasLoaded = loadDaRingFilmLazyVideo(video);
    if (forceReload && ! sourceWasLoaded && video.readyState === 0) {
      video.load();
    }

    if (document.hidden) {
      return;
    }

    try {
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function() {
          scheduleDaRingFilmVideoRetry(video);
        });
      }
    } catch (error) {
      scheduleDaRingFilmVideoRetry(video);
    }

    if (video.readyState === 0) {
      scheduleDaRingFilmVideoRetry(video);
    }
  }

  function bindDaRingFilmVideoRecovery(video) {
    if (! video || video.dataset.daRingFilmRecoveryReady === "true") {
      return;
    }

    video.dataset.daRingFilmRecoveryReady = "true";
    prepareDaRingFilmVideo(video);

    var retryWhenReady = function() {
      if (video.dataset.daRingFilmWantsPlay === "true") {
        playDaRingFilmLazyVideo(video, false);
      }
    };

    video.addEventListener("loadeddata", retryWhenReady);
    video.addEventListener("canplay", retryWhenReady);
    video.addEventListener("stalled", function() {
      scheduleDaRingFilmVideoRetry(video);
    });
    video.addEventListener("error", function() {
      scheduleDaRingFilmVideoRetry(video);
    });
    video.addEventListener("playing", function() {
      clearDaRingFilmVideoRetry(video);
      video.dataset.daRingFilmRetryCount = "0";
    });

    var frame = video.closest(
      "[data-da-ring-film-video-frame], .card-video-wrap, .rv-video-box"
    );

    if (frame && frame.dataset.daRingFilmTapReady !== "true") {
      frame.dataset.daRingFilmTapReady = "true";
      frame.addEventListener("click", function(event) {
        if (
          event.target.closest
          && event.target.closest("[data-da-ring-film-fullscreen]")
        ) {
          return;
        }

        video.dataset.daRingFilmRetryCount = "0";
        clearDaRingFilmVideoRetry(video);
        playDaRingFilmLazyVideo(video, true);
      });
    }
  }

  function isDaRingFilmVideoNearViewport(video) {
    var rect = video.getBoundingClientRect();
    var margin = window.matchMedia("(max-width: 749px)").matches
      ? 120
      : 300;

    return rect.bottom >= -margin && rect.top <= window.innerHeight + margin;
  }

  function resumeVisibleDaRingFilmVideos(scope) {
    var container = scope && scope.querySelectorAll
      ? scope
      : document;
    var selector = container.matches && container.matches("[data-da-ring-film]")
      ? "video"
      : "[data-da-ring-film] video";

    container.querySelectorAll(selector).forEach(function(video) {
      bindDaRingFilmVideoRecovery(video);

      if (isDaRingFilmVideoNearViewport(video)) {
        playDaRingFilmLazyVideo(video, false);
      }
    });
  }

  function getDaRingFilmLazyVideoObserver() {
    if (!("IntersectionObserver" in window)) {
      return null;
    }

    if (window.daRingFilmLazyVideoObserver) {
      return window.daRingFilmLazyVideoObserver;
    }

    window.daRingFilmLazyVideoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var video = entry.target;

        if (entry.isIntersecting) {
          video.dataset.daRingFilmWantsPlay = "true";
          playDaRingFilmLazyVideo(video, false);
        } else {
          video.dataset.daRingFilmWantsPlay = "false";
          clearDaRingFilmVideoRetry(video);
          video.pause();
        }
      });
    }, {
      rootMargin: window.matchMedia("(max-width: 749px)").matches
        ? "120px 0px"
        : "300px 0px",
      threshold: 0.01
    });

    return window.daRingFilmLazyVideoObserver;
  }

  /* 鼠标移入右侧视频 → Hero 挂 .is-media-expanded，视频向左铺满整个首屏。
     只在支持 hover 的桌面视口生效；触屏 / 窄屏不响应，避免点了就收不回来。 */
  function bindDaRingFilmHeroExpand(hero) {
    if (hero.dataset.daRingFilmExpandReady === "true") {
      return;
    }

    hero.dataset.daRingFilmExpandReady = "true";

    var media = hero.querySelector(".rcf-hero__media");
    if (! media) {
      return;
    }

    var canHover = window.matchMedia(
      "(hover: hover) and (pointer: fine) and (min-width: 750px)"
    );

    media.addEventListener("mouseenter", function() {
      if (canHover.matches) {
        hero.classList.add("is-media-expanded");
      }
    });

    media.addEventListener("mouseleave", function() {
      hero.classList.remove("is-media-expanded");
    });

    if (canHover.addEventListener) {
      canHover.addEventListener("change", function() {
        if (! canHover.matches) {
          hero.classList.remove("is-media-expanded");
        }
      });
    }
  }

  function initDaRingFilm(scope) {
    var root = scope && scope.querySelector
      ? scope
      : document;
    var blocks = root.querySelectorAll(".da-ring-film__fade-in");

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-animate");
            observer.unobserve(entry.target);
          }
        });
      }, {threshold: 0.1});

      blocks.forEach(function(block) {
        if (! block.classList.contains("show-animate")) {
          observer.observe(block);
        }
      });
    } else {
      blocks.forEach(function(block) {
        block.classList.add("show-animate");
      });
    }

    root.querySelectorAll("[data-da-ring-film] video").forEach(function(video) {
      bindDaRingFilmVideoRecovery(video);
    });

    root.querySelectorAll(".rcf-hero").forEach(function(hero) {
      bindDaRingFilmHeroExpand(hero);
    });

    var lazyVideoObserver = getDaRingFilmLazyVideoObserver();
    root.querySelectorAll(
      "[data-da-ring-film-video], [data-da-ring-film-lazy-video]"
    ).forEach(function(video) {
      if (video.dataset.daRingFilmLazyReady === "true") {
        return;
      }

      video.dataset.daRingFilmLazyReady = "true";

      if (lazyVideoObserver) {
        lazyVideoObserver.observe(video);
      } else {
        playDaRingFilmLazyVideo(video, false);
      }
    });

    resumeVisibleDaRingFilmVideos(root);

    root.querySelectorAll("[data-da-ring-film-fullscreen]").forEach(function(button) {
      if (button.dataset.daRingFilmReady === "true") {
        return;
      }

      button.dataset.daRingFilmReady = "true";
      button.addEventListener("click", function() {
        var frame = button.closest("[data-da-ring-film-video-frame]");
        var video = frame
          ? frame.querySelector("video")
          : null;

        if (document.fullscreenElement) {
          document.exitFullscreen();
          return;
        }

        if (frame && frame.requestFullscreen) {
          frame.requestFullscreen();
          return;
        }

        if (video && video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        }
      });
    });

    root.querySelectorAll(".rcf-reel__quote").forEach(function(content) {
      if (window.matchMedia("(max-width: 749px)").matches) {
        return;
      }

      if (content.dataset.daRingFilmTooltipReady === "true") {
        return;
      }

      content.dataset.daRingFilmTooltipReady = "true";
      var wrap = content.closest(".rcf-reel__text");
      var tooltip = wrap
        ? wrap.querySelector(".rv-tooltip")
        : null;

      if (! tooltip) {
        return;
      }

      tooltip.textContent = content.dataset.fullText || content.textContent;

      content.addEventListener("mouseenter", function() {
        tooltip.classList.add("is-visible");
      });

      content.addEventListener("mousemove", function(event) {
        tooltip.style.left = event.clientX + 12 + "px";
        tooltip.style.top = event.clientY + 12 + "px";
      });

      content.addEventListener("mouseleave", function() {
        tooltip.classList.remove("is-visible");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initDaRingFilm(document);
    });
  } else {
    initDaRingFilm(document);
  }

  document.addEventListener("shopify:section:load", function(event) {
    initDaRingFilm(event.target);
  });

  if (! window.daRingFilmVideoRecoveryListenersReady) {
    window.daRingFilmVideoRecoveryListenersReady = true;

    document.addEventListener("visibilitychange", function() {
      if (! document.hidden) {
        resumeVisibleDaRingFilmVideos(document);
      }
    });

    window.addEventListener("pageshow", function() {
      window.setTimeout(function() {
        resumeVisibleDaRingFilmVideos(document);
      }, 0);
    });

    window.addEventListener("online", function() {
      resumeVisibleDaRingFilmVideos(document);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-ring-film"] && !Shopify.designMode) return;
  try {
    
  function prepareDaRingFilmVideo(video) {
    if (! video) {
      return;
    }

    video.autoplay = true;
    video.defaultMuted = true;
    video.muted = true;
    video.playsInline = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
  }

  function clearDaRingFilmVideoRetry(video) {
    if (! video || ! video.daRingFilmRetryTimer) {
      return;
    }

    window.clearTimeout(video.daRingFilmRetryTimer);
    video.daRingFilmRetryTimer = null;
  }

  function loadDaRingFilmLazyVideo(video) {
    if (! video) {
      return false;
    }

    prepareDaRingFilmVideo(video);

    var sources = video.querySelectorAll("source[data-src]");
    if (! sources.length || video.dataset.daRingFilmLoaded === "true") {
      return false;
    }

    sources.forEach(function(source) {
      source.src = source.dataset.src;
      source.removeAttribute("data-src");
    });

    video.dataset.daRingFilmLoaded = "true";
    video.preload = "metadata";
    video.load();
    return true;
  }

  function scheduleDaRingFilmVideoRetry(video) {
    if (
      ! video
      || video.dataset.daRingFilmWantsPlay !== "true"
      || video.daRingFilmRetryTimer
    ) {
      return;
    }

    var retryCount = Number(video.dataset.daRingFilmRetryCount || 0);
    if (retryCount >= 3) {
      return;
    }

    video.daRingFilmRetryTimer = window.setTimeout(function() {
      video.daRingFilmRetryTimer = null;

      if (
        document.hidden
        || video.dataset.daRingFilmWantsPlay !== "true"
      ) {
        return;
      }

      video.dataset.daRingFilmRetryCount = String(retryCount + 1);

      if (video.error || video.networkState === 3) {
        video.load();
      }

      playDaRingFilmLazyVideo(video, false);
    }, 1800 * (retryCount + 1));
  }

  function playDaRingFilmLazyVideo(video, forceReload) {
    if (! video) {
      return;
    }

    prepareDaRingFilmVideo(video);
    video.dataset.daRingFilmWantsPlay = "true";

    var sourceWasLoaded = loadDaRingFilmLazyVideo(video);
    if (forceReload && ! sourceWasLoaded && video.readyState === 0) {
      video.load();
    }

    if (document.hidden) {
      return;
    }

    try {
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function() {
          scheduleDaRingFilmVideoRetry(video);
        });
      }
    } catch (error) {
      scheduleDaRingFilmVideoRetry(video);
    }

    if (video.readyState === 0) {
      scheduleDaRingFilmVideoRetry(video);
    }
  }

  function bindDaRingFilmVideoRecovery(video) {
    if (! video || video.dataset.daRingFilmRecoveryReady === "true") {
      return;
    }

    video.dataset.daRingFilmRecoveryReady = "true";
    prepareDaRingFilmVideo(video);

    var retryWhenReady = function() {
      if (video.dataset.daRingFilmWantsPlay === "true") {
        playDaRingFilmLazyVideo(video, false);
      }
    };

    video.addEventListener("loadeddata", retryWhenReady);
    video.addEventListener("canplay", retryWhenReady);
    video.addEventListener("stalled", function() {
      scheduleDaRingFilmVideoRetry(video);
    });
    video.addEventListener("error", function() {
      scheduleDaRingFilmVideoRetry(video);
    });
    video.addEventListener("playing", function() {
      clearDaRingFilmVideoRetry(video);
      video.dataset.daRingFilmRetryCount = "0";
    });

    var frame = video.closest(
      "[data-da-ring-film-video-frame], .card-video-wrap, .rv-video-box"
    );

    if (frame && frame.dataset.daRingFilmTapReady !== "true") {
      frame.dataset.daRingFilmTapReady = "true";
      frame.addEventListener("click", function(event) {
        if (
          event.target.closest
          && event.target.closest("[data-da-ring-film-fullscreen]")
        ) {
          return;
        }

        video.dataset.daRingFilmRetryCount = "0";
        clearDaRingFilmVideoRetry(video);
        playDaRingFilmLazyVideo(video, true);
      });
    }
  }

  function isDaRingFilmVideoNearViewport(video) {
    var rect = video.getBoundingClientRect();
    var margin = window.matchMedia("(max-width: 749px)").matches
      ? 120
      : 300;

    return rect.bottom >= -margin && rect.top <= window.innerHeight + margin;
  }

  function resumeVisibleDaRingFilmVideos(scope) {
    var container = scope && scope.querySelectorAll
      ? scope
      : document;
    var selector = container.matches && container.matches("[data-da-ring-film]")
      ? "video"
      : "[data-da-ring-film] video";

    container.querySelectorAll(selector).forEach(function(video) {
      bindDaRingFilmVideoRecovery(video);

      if (isDaRingFilmVideoNearViewport(video)) {
        playDaRingFilmLazyVideo(video, false);
      }
    });
  }

  function getDaRingFilmLazyVideoObserver() {
    if (!("IntersectionObserver" in window)) {
      return null;
    }

    if (window.daRingFilmLazyVideoObserver) {
      return window.daRingFilmLazyVideoObserver;
    }

    window.daRingFilmLazyVideoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var video = entry.target;

        if (entry.isIntersecting) {
          video.dataset.daRingFilmWantsPlay = "true";
          playDaRingFilmLazyVideo(video, false);
        } else {
          video.dataset.daRingFilmWantsPlay = "false";
          clearDaRingFilmVideoRetry(video);
          video.pause();
        }
      });
    }, {
      rootMargin: window.matchMedia("(max-width: 749px)").matches
        ? "120px 0px"
        : "300px 0px",
      threshold: 0.01
    });

    return window.daRingFilmLazyVideoObserver;
  }

  function initDaRingFilm(scope) {
    var root = scope && scope.querySelector
      ? scope
      : document;
    var blocks = root.querySelectorAll(".da-ring-film__fade-in");

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-animate");
            observer.unobserve(entry.target);
          }
        });
      }, {threshold: 0.1});

      blocks.forEach(function(block) {
        if (! block.classList.contains("show-animate")) {
          observer.observe(block);
        }
      });
    } else {
      blocks.forEach(function(block) {
        block.classList.add("show-animate");
      });
    }

    root.querySelectorAll("[data-da-ring-film] video").forEach(function(video) {
      bindDaRingFilmVideoRecovery(video);
    });

    var lazyVideoObserver = getDaRingFilmLazyVideoObserver();
    root.querySelectorAll(
      "[data-da-ring-film-video], [data-da-ring-film-lazy-video]"
    ).forEach(function(video) {
      if (video.dataset.daRingFilmLazyReady === "true") {
        return;
      }

      video.dataset.daRingFilmLazyReady = "true";

      if (lazyVideoObserver) {
        lazyVideoObserver.observe(video);
      } else {
        playDaRingFilmLazyVideo(video, false);
      }
    });

    resumeVisibleDaRingFilmVideos(root);

    root.querySelectorAll("[data-da-ring-film-fullscreen]").forEach(function(button) {
      if (button.dataset.daRingFilmReady === "true") {
        return;
      }

      button.dataset.daRingFilmReady = "true";
      button.addEventListener("click", function() {
        var frame = button.closest("[data-da-ring-film-video-frame]");
        var video = frame
          ? frame.querySelector("video")
          : null;

        if (document.fullscreenElement) {
          document.exitFullscreen();
          return;
        }

        if (frame && frame.requestFullscreen) {
          frame.requestFullscreen();
          return;
        }

        if (video && video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        }
      });
    });

    root.querySelectorAll(".rv-content").forEach(function(content) {
      if (window.matchMedia("(max-width: 749px)").matches) {
        return;
      }

      if (content.dataset.daRingFilmTooltipReady === "true") {
        return;
      }

      content.dataset.daRingFilmTooltipReady = "true";
      var wrap = content.closest(".rv-text-wrap");
      var tooltip = wrap
        ? wrap.querySelector(".rv-tooltip")
        : null;

      if (! tooltip) {
        return;
      }

      tooltip.textContent = content.dataset.fullText || content.textContent;

      content.addEventListener("mouseenter", function() {
        tooltip.classList.add("is-visible");
      });

      content.addEventListener("mousemove", function(event) {
        tooltip.style.left = event.clientX + 12 + "px";
        tooltip.style.top = event.clientY + 12 + "px";
      });

      content.addEventListener("mouseleave", function() {
        tooltip.classList.remove("is-visible");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initDaRingFilm(document);
    });
  } else {
    initDaRingFilm(document);
  }

  document.addEventListener("shopify:section:load", function(event) {
    initDaRingFilm(event.target);
  });

  if (! window.daRingFilmVideoRecoveryListenersReady) {
    window.daRingFilmVideoRecoveryListenersReady = true;

    document.addEventListener("visibilitychange", function() {
      if (! document.hidden) {
        resumeVisibleDaRingFilmVideos(document);
      }
    });

    window.addEventListener("pageshow", function() {
      window.setTimeout(function() {
        resumeVisibleDaRingFilmVideos(document);
      }, 0);
    });

    window.addEventListener("online", function() {
      resumeVisibleDaRingFilmVideos(document);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diamaura-about-pc"] && !Shopify.designMode) return;
  try {
    
  function initDaAboutPc(scope) {
    var root = scope && scope.querySelector
      ? scope
      : document;
    var blocks = root.querySelectorAll(".da-about-pc .fade-in");

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-animate");
            observer.unobserve(entry.target);
          }
        });
      }, {threshold: 0.1});

      blocks.forEach(function(block) {
        if (! block.classList.contains("show-animate")) {
          observer.observe(block);
        }
      });
    } else {
      blocks.forEach(function(block) {
        block.classList.add("show-animate");
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initDaAboutPc(document);
    });
  } else {
    initDaAboutPc(document);
  }

  document.addEventListener("shopify:section:load", function(event) {
    initDaAboutPc(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-ring-crafting-film"] && !Shopify.designMode) return;
  try {
    
  function initFindRingCraftingFilm(root) {
    if (! root || root.dataset.findRingCraftingFilmReady === "true") return;
    


    var form = root.querySelector("[data-find-ring-crafting-film-form]");
    var message = root.querySelector("[data-find-ring-crafting-film-message]");
    var result = root.querySelector("[data-find-ring-crafting-film-result]");
    var button = form
      ? form.querySelector("button[type='submit']")
      : null;
    if (! form || ! message || ! result || ! button) return;
    


    var endpointUrl = root.dataset.endpointUrl || "";
    var requiredMessage = root.dataset.requiredMessage || "";
    var loadingMessage = root.dataset.loadingMessage || "";
    var readyMessage = root.dataset.readyMessage || "";
    var notReadyMessage = root.dataset.notReadyMessage || "";
    var notFoundMessage = root.dataset.notFoundMessage || "";
    var errorMessage = root.dataset.errorMessage || "";
    var playVideoLabel = root.dataset.playVideoLabel || "";
    var defaultButtonText = button.textContent;
    var stages = [
      {
        percent: root.dataset.stageOnePercent || "",
        title: root.dataset.stageOneTitle || "",
        text: root.dataset.stageOneText || "",
        film: root.dataset.stageOneFilm || "",
        caption: root.dataset.stageOneCaption || "",
        footer: root.dataset.stageOneFooter || ""
      }, {
        percent: root.dataset.stageTwoPercent || "",
        title: root.dataset.stageTwoTitle || "",
        text: root.dataset.stageTwoText || "",
        film: root.dataset.stageTwoFilm || "",
        caption: root.dataset.stageTwoCaption || "",
        footer: root.dataset.stageTwoFooter || ""
      }, {
        percent: root.dataset.stageThreePercent || "",
        title: root.dataset.stageThreeTitle || "",
        text: root.dataset.stageThreeText || "",
        film: root.dataset.stageThreeFilm || "",
        caption: root.dataset.stageThreeCaption || "",
        footer: root.dataset.stageThreeFooter || ""
      }
    ];
    var productionTitle = root.dataset.productionTitle || "";
    var productionText = root.dataset.productionText || "";

    function showMessage(text) {
      message.textContent = text || "";
      message.hidden = ! text;
    }

    function clearResult() {
      result.innerHTML = "";
      result.hidden = true;
      root.classList.remove("has-ready-result");
    }

    function setLoading(isLoading) {
      button.disabled = isLoading;
      button.textContent = isLoading
        ? loadingMessage
        : defaultButtonText;
    }

    function isUsableUrl(url) {
      return /^https?:\/\//i.test(String(url || ""));
    }

    function getVideoGroupKey(video) {
      if (video.posterUrl) return video.posterUrl;
      


      return String(video.url || "").replace(/\.(HD|SD)-[^.]+\.mp4$/i, "");
    }

    function sourceScore(video) {
      var isMp4 = video.mimeType === "video/mp4" || video.format === "mp4";
      return(
        isMp4
          ? 100000
          : 0
      ) + Number(video.width || 0);
    }

    function selectVideoFiles(data) {
      var groups = {};
      var videos = Array.isArray(data.videos)
        ? data.videos
        : [];

      videos.forEach(function(video) {
        if (! video || ! isUsableUrl(video.url)) return;
        


        var key = getVideoGroupKey(video);
        if (! groups[key] || sourceScore(video) > sourceScore(groups[key])) {
          groups[key] = video;
        }
      });

      var selected = Object.keys(groups).map(function(key) {
        return groups[key];
      });

      if (! selected.length && isUsableUrl(data.videoUrl)) {
        selected.push({
          url: data.videoUrl,
          posterUrl: data.posterUrl || "",
          mimeType: "video/mp4",
          format: "mp4"
        });
      }

      return selected;
    }

    function createTextElement(tagName, className, text) {
      var element = document.createElement(tagName);
      element.className = className;
      element.textContent = text || "";
      return element;
    }

    function createProductionCard() {
      var card = document.createElement("div");
      card.className = "find-ring-crafting-film__film-card find-ring-crafting-film__film-card--production";

      var production = document.createElement("div");
      production.className = "find-ring-crafting-film__production";

      var inner = document.createElement("div");
      inner.className = "find-ring-crafting-film__production-inner";
      inner.innerHTML = ['<svg class="find-ring-crafting-film__production-mark" viewBox="0 0 41 32" aria-hidden="true" focusable="false">', '<path fill="none" stroke="currentColor" stroke-width="1.2" d="M36.4 12.4 28.1 2.8H12.9L4 11.8 20.5 29.8 36.4 12.4Z"/>', '<path fill="none" stroke="currentColor" stroke-width="1.2" d="M12.9 3.5 20.5 29.8 28.1 3.5M4 11.8h32.4"/>', '</svg>'].join("");

      inner.appendChild(createTextElement("p", "find-ring-crafting-film__production-title", productionTitle));
      inner.appendChild(createTextElement("p", "find-ring-crafting-film__production-text", productionText));
      production.appendChild(inner);
      card.appendChild(production);

      return card;
    }

    function createVideoCard(video, stage) {
      var card = document.createElement("div");
      card.className = "find-ring-crafting-film__film-card";

      var videoEl = document.createElement("video");
      videoEl.controls = true;
      videoEl.preload = "metadata";
      videoEl.playsInline = true;
      if (isUsableUrl(video.posterUrl)) {
        videoEl.poster = video.posterUrl;
      }

      var source = document.createElement("source");
      source.src = video.url;
      if (video.mimeType) {
        source.type = video.mimeType;
      }
      videoEl.appendChild(source);

      var playButton = document.createElement("button");
      playButton.className = "find-ring-crafting-film__film-play";
      playButton.type = "button";
      playButton.setAttribute("aria-label", playVideoLabel);
      playButton.dataset.progressPlay = "true";

      var meta = document.createElement("div");
      meta.className = "find-ring-crafting-film__film-meta";
      meta.appendChild(createTextElement("p", "find-ring-crafting-film__film-name", stage.film));
      meta.appendChild(createTextElement("p", "find-ring-crafting-film__film-caption", stage.caption));

      card.appendChild(videoEl);
      card.appendChild(playButton);
      card.appendChild(meta);

      videoEl.addEventListener("play", function() {
        card.classList.add("is-playing");
      });
      videoEl.addEventListener("pause", function() {
        card.classList.remove("is-playing");
      });

      return card;
    }

    function renderVideos(data) {
      var videos = selectVideoFiles(data);
      clearResult();

      var progress = document.createElement("div");
      progress.className = "find-ring-crafting-film__progress";

      var grid = document.createElement("div");
      grid.className = "find-ring-crafting-film__progress-grid";

      stages.forEach(function(stage, index) {
        var video = videos[index];
        var item = document.createElement("article");
        item.className = "find-ring-crafting-film__progress-stage";
        if (! video) {
          item.className += " is-pending";
        }

        item.appendChild(createTextElement("p", "find-ring-crafting-film__progress-percent", stage.percent));

        var dot = document.createElement("span");
        dot.className = "find-ring-crafting-film__progress-dot";
        dot.setAttribute("aria-hidden", "true");
        item.appendChild(dot);

        item.appendChild(createTextElement("h3", "find-ring-crafting-film__progress-title", stage.title));
        item.appendChild(createTextElement("p", "find-ring-crafting-film__progress-text", stage.text));
        item.appendChild(
          video
            ? createVideoCard(video, stage)
            : createProductionCard()
        );
        item.appendChild(createTextElement("p", "find-ring-crafting-film__stage-footer", stage.footer));

        grid.appendChild(item);
      });

      progress.appendChild(grid);
      result.appendChild(progress);
      result.hidden = false;
      root.classList.add("has-ready-result");
    }

    result.addEventListener("click", function(event) {
      var playButton = event.target.closest("[data-progress-play]");
      if (! playButton) return;
      


      var card = playButton.closest(".find-ring-crafting-film__film-card");
      var video = card
        ? card.querySelector("video")
        : null;
      if (! video) return;
      


      video.play();
      card.classList.add("is-playing");
    });

    form.addEventListener("submit", async function(event) {
      var requiredFields = Array.prototype.slice.call(form.querySelectorAll("[required]"));
      var firstInvalid = requiredFields.find(function(field) {
        return ! field.value.trim();
      });

      event.preventDefault();
      clearResult();

      if (firstInvalid) {
        showMessage(requiredMessage);
        firstInvalid.focus();
        return;
      }

      if (! endpointUrl) {
        showMessage(errorMessage);
        return;
      }

      setLoading(true);
      showMessage(loadingMessage);

      try {
        var response = await fetch(endpointUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(
            {orderNumber: form.elements.order_number.value, lastName: form.elements.last_name.value}
          )
        });
        var data = await response.json();

        if (data.status === "ready" && data.ok) {
          showMessage("");
          renderVideos(data);
          return;
        }

        if (data.status === "not_ready" && data.ok) {
          showMessage(data.message || notReadyMessage);
          return;
        }

        if (data.status === "not_found") {
          showMessage(data.message || notFoundMessage);
          return;
        }

        showMessage(data.message || errorMessage);
      } catch (error) {
        showMessage(errorMessage);
      } finally {
        setLoading(false);
      }
    });

    root.dataset.findRingCraftingFilmReady = "true";
  }

  document.querySelectorAll("[data-find-ring-crafting-film]").forEach(initFindRingCraftingFilm);
  document.addEventListener("shopify:section:load", function(event) {
    event.target.querySelectorAll("[data-find-ring-crafting-film]").forEach(initFindRingCraftingFilm);
  });

  } catch(e) { console.error(e); }
})();
})();
